/**
 * Angular Component
 */
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * Services Component
 */
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { FileUploadService } from '../../../dataservices/file-upload.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { GetService } from '../../../dataservices/get.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { UploadfileWithForkService } from '../../../dataservices/uploadfile-with-fork.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { PostingService } from '../posting.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../../analytics-event/analytics.model';
/**
 * Constant import.
 */
import { EVENT_NAME } from './../../../analytics-event/analytics.constant';
import { CONVERT_TO_BYTES_DECIMAL, REPOST_STATUS, SCREEN_NAME, POLL_QUESTION_TEXT_LIMIT, NUMBERS, FEED_KIND, PRODUCT_TYPE_CONSTANT, EXPLORE_SECTION, STATUS_CODE, PRODUCT_TYPE_CONSTANT_NAME, CTA_TYPE, ACTION_TYPE, ACTION_ON  } from '../../../constants/app.constants';
/**
 * Service imports.
 */
import { GetwebService } from '../../../dataservices/web/getweb.service';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';

let contentUrl;

/**
 * CreatePost Component
 */
@Component({
  selector: 'app-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.scss']
})
export class CreatePostComponent implements OnInit, OnDestroy {

  @Input() callingFrom: string;
  public create_post_image = {
    prflclass: 'text-uppercase box-size-56 text-center rounded-circle text-white d-table-cell align-middle secondary-paragraph',
    prflpic: '',
    prflfname: '',
    prflmname: '',
    prfllname: '',
    prflrname: '',
    prflcid: '',
    prfltype: '',
    prflpicclass: 'rounded-circle post-pic box-size-56',
    badge: { is_verified: 0, is_show: true },
    full_name: '',
    is_action: false,
    partial_permission_state: ''
  };

  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };

  @Output() nextPostScreen = new EventEmitter();
  public show_poll = false;
  public mediaObj = [];
  public post_content = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public profile_data: any;
  public showColor = false;
  public showNmaeSelected = true;
  public isConfirmModalShown = false;
  public confirmInfo = '';
  public openMediaIndex = 0;
  public metaData = '';
  public meta_api_in_process = false;
  public content_paceholder = this.mls.languageText.create_posting.key3;
  public max_media_err: string[] = [];
  public media_limit = 10;
  public url = { local: '', obj: '' };
  public tooltip_data = [];
  public tooltip_data_tag_peaple = [];
  public mediaModal = false;
  public is_show_post_media_modal = false;
  public is_show_post_media_modal_data = [];
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };

  /**
   * Get the pencil media for the edit post.
   */
  private pencilEditMedia: number;
  /**
   * Files converted from url.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public urlToFiles: any;
  /**
   * Repost status object.
   */
  public repostStatus = REPOST_STATUS;
  /**
   * Screen name.
   */
  public callingfrom = SCREEN_NAME.CREATE_REPOST;
  /**
   * Reposted data.
   */
  public repostedData = this.dss.webinarRepostObject;
  /**
   * Poll question Text limit.
   */
  public PollQuestiontextLimit = POLL_QUESTION_TEXT_LIMIT;
  /**
   * Numbers from cinstant.
   */
  public numbers = NUMBERS;
  /**
   * Product type constant
   */
  public productTypeConstant = PRODUCT_TYPE_CONSTANT;
  /**
   * Constant expression
   */
     public exploreSection = EXPLORE_SECTION;
   /**
    *  Post Pop up flag
    */
     public postPopup = false;
  /**
   * CreatePost Component
   */
  constructor(
    private getSer: GetService,
    private fileUs: FileUploadService,
    private postApiSer: PostApiService,
    private masterSer: MasterserviceService,
    public multiLangService: MultiLangService,
    public dss: DataStorageService,
    public fcs: FunCollectionService,
    public jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    public fileUsFork: UploadfileWithForkService,
    private http: HttpClient,
    private gws: GetwebService,
    private analyticSdk: Analytics,
    private postingService: PostingService) {

    this.create_post_image.prflcid = this.dss.user_profile_data.profile.custom_id;
    this.create_post_image.prflpic = this.dss.user_profile_data.profile.profile_pic_path;
    this.create_post_image.prflrname = this.dss.user_profile_data.profile.registered_name;
    this.create_post_image.prflfname = this.dss.user_profile_data.profile.first_name;
    this.create_post_image.prfllname = this.dss.user_profile_data.profile.last_name;
    this.create_post_image.full_name = this.dss.user_profile_data.profile.first_name + ' ' + this.dss.user_profile_data.profile.middle_name + ' ' + this.dss.user_profile_data.profile.last_name;
    this.create_post_image.badge.is_verified = (this.dss.user_profile_data.profile.permission == 'all') ? 1 : 0;
    this.create_post_image.partial_permission_state = this.dss.user_profile_data.profile.partial_permission_state;
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.tooltip_data = this.dss.tooltip_list.filter(obj => obj.screen_identifier == 'FEED_POSTING');
    this.profile_data = this.dss.user_profile_data;
    if (this.dss.posting_data.screen1.media.length > 0 ||
      this.dss.posting_data.screen1.content != '' ||
      this.dss.temp_post_media.length) {
      this.showColor = true;
      if (this.dss.posting_data.isRepost === REPOST_STATUS.ONE) {
        this.dss.isRepostStatus = REPOST_STATUS.TWO;
        this.dss.repostProductId = this.dss.posting_data.repostProductId;
        this.dss.repostProductType = this.dss.posting_data.repostProductType;

        if (this.dss.repostProductType === PRODUCT_TYPE_CONSTANT.WEBINAR) {
          this.getSer.getWebinarList('', '', this.dss.repostProductId).subscribe(resData => {
            this.repostedData = resData.data.records['webinar'];
          });
        } else if (this.dss.repostProductType === PRODUCT_TYPE_CONSTANT.FEED) {
          this.gws.getfeedetailNew(this.dss.repostProductId).subscribe(resData => {
            this.repostedData = resData.data.feed;
            this.dss.tagedUser.push(resData.data.feed.data.user_profile);
            this.dss.posting_data.screen1.tag_to.push(resData.data.feed.data.user_profile);
          });
        }
      }

    } else {
      this.showColor = false;
    }
    if (this.dss.posting_data.screen1.feed_kind == 'poll') {
      this.content_paceholder = this.mls.languageText.create_posting.key8;
    }
    /**
     * Session start time.
     */
    this.sessiontime.start_time = new Date().getTime().toString();
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0',
      source: this.callingFrom,
      current_screen_name: SCREEN_NAME.FEED_POSTING,
      start_time: parseInt(this.sessiontime.start_time)
    };
    this.analyticSdk.analyticService.ENTRY(entryData);
    this.postingService.postingScreen = SCREEN_NAME.FEED_POSTING;
    if(this.dss.isRepostStatus=== REPOST_STATUS.ONE){
      this.dss.isRepostStatus= REPOST_STATUS.TWO;
      if(this.dss.certificateUrl && this.dss.certificateUrl !== ''){
        this.convertToBase64(this.dss.certificateUrl);
      }
      if (!this.dss.posting_data.screen1.content) {
        this.repostdefaultContent();
      }
    } else if (this.dss.posting_data.isRepost !== REPOST_STATUS.ONE && this.dss.posting_data.isRepost !== REPOST_STATUS.ZERO) {
      this.dss.isRepostStatus = REPOST_STATUS.ZERO;
      this.dss.webinarRepostObject = '';
    }
      this.getUserAssociation();
      this.getSpecialityList();
  }

  /**
   * to open gallary
   */
  openGallery(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.OPTION_BAR, ACTION_TYPE.CLICK, ACTION_ON.ATTACH_MEDIA, null);
  }

  /**
   * open document
   */
  openDocument(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.OPTION_BAR, ACTION_TYPE.CLICK, ACTION_ON.ATTACH_DOCUMENT, null);
  }
  /**
   * show Poll
   */
  showPoll(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.OPTION_BAR, ACTION_TYPE.CLICK, ACTION_ON.ASK_QUESTION, null);
    if (this.dss.isRepostStatus === NUMBERS.TWO) {
      return;
    }
    if (this.dss.posting_data.screen1.content != '' || this.dss.temp_post_media.length > 0 || this.dss.posting_data.screen1.tag_to.length != 0) {
      this.confirmInfo = this.mls.languageText.create_posting.key18;
      this.isConfirmModalShown = true;
    } else {
      this.show_poll = true;
      this.dss.posting_data.screen1.feed_kind = 'poll';
      this.content_paceholder = this.mls.languageText.create_posting.key8;
    }
  }

  /**
   * Close Post Modal
   */
  ClosePostModal(): void {
    // No Code
  }

  /**
   * add Poll
   */
  addPoll(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.ADD_MORE_OPTION, null);
    const t = { placeholder: this.dss.posting_data.screen1.poll.length, value: '' };
    this.dss.posting_data.screen1.poll.push(t);
  }

  /**
   * remove Poll
   */
  removePoll(pollIdx): void {
    this.dss.posting_data.screen1.poll.splice(pollIdx, 1);
  }

  /**
   * is anonymous
   */
  is_anonymous(status): void {
    if (status === this.dss.posting_data.screen1.is_anonymous)
      return;
    if (status == 1) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.BAR, ACTION_TYPE.CLICK, ACTION_ON.ANONYMOUS_POSTING, null);
    }
    this.dss.posting_data.screen1.is_anonymous = status;
  }

  /**
   * validate Input
   */
  validateInput(e): void {
    const x = e.target.value.trim();
    if (x.length == 0) {
      e.target.value = '';
      this.dss.posting_data.screen1.content = '';
    }
    setTimeout(() => {
      if (x.length != 0 || this.dss.posting_data.screen1.media.length > 0) {
        if (this.dss.posting_data.screen1.feed_kind != 'poll') {
          this.showColor = true;
        } else {
          if (this.dss.posting_data.screen1.poll[0].value != '' && this.dss.posting_data.screen1.poll[1].value != '') {
            this.showColor = true;
          } else {
            this.showColor = false;
          }
        }
      } else {
        this.showColor = (this.dss.temp_post_media.length > NUMBERS.ZERO || this.dss.posting_data.screen1.content != '') ? true : false;
      }
    }, 50);
  }

  /**
   * validate From Poll
   */
  validateFromPoll(e, pollIdx): void {
    const x = e.target.value.trim();
    if (x.length == 0) {
      e.target.value = '';
      this.dss.posting_data.screen1.poll[pollIdx].value = '';
    }
    setTimeout(() => {
      if (this.dss.posting_data.screen1.content != '') {
        const temp = this.dss.posting_data.screen1.poll.filter(obj => obj.value != '');
        if (temp.length > 1) {
          this.showColor = true;
        } else {
          this.showColor = false;
        }
      } else {
        this.showColor = false;
      }
    }, 50);

  }

  /**
   * close Post Modal
   */
  closePostModal(): void {
    this.dss.posting_data.screen1.content = this.dss.posting_data.screen1.content.trim();

    if (this.dss.posting_data.screen1.content != '' || this.dss.temp_post_media.length > 0 || this.dss.posting_data.screen1.tag_to.length > 0 || this.dss.posting_data.screen1.poll[0].value != '' || this.dss.posting_data.screen1.poll[1].value != '' || this.dss.posting_data.screen2.selected_speciality.length > 0 || this.dss.posting_data.screen3.selected_association.length > 0 || this.dss.posting_data.screen3.selected_community.length > 0) {
      this.nextPostScreen.emit(5.1);
      if (this.dss.isRepostStatus === REPOST_STATUS.ONE) {
        this.dss.isRepostStatus = REPOST_STATUS.TWO;
      }
    } else {
      this.nextPostScreen.emit(6);
    }
  }

  /**
   * onSelect File
   */
  onSelectFile(event): void {

    setTimeout(() => {
      event.target.value = '';
    }, 3000);

    this.max_media_err = [];
    // const temp = 0;
    if (event.target.files && event.target.files[0]) {
      if ((this.dss.temp_post_media.length + event.target.files.length) > this.media_limit) {
        this.max_media_err.push('max ' + this.media_limit + ' media allowed');
        // temp = this.media_limit - this.dss.temp_post_media.length;
        event.target.value = '';
        event.target.files = [];
        event.target.files = '';
        return;
      }
      const filesAmount = this.media_limit - this.dss.temp_post_media.length;
      for (let i = 0, j = this.dss.temp_post_media.length; i < filesAmount; i++, j++) {
        if (!event.target.files[i]) {
          continue;
        }
        let type = event.target.files[i].type;

        const validationSuccess = this.commonValidation(event.target.files[i]);
        if (!validationSuccess) {
          continue;
        }

        type = type.split('/');
        if (type[0] == 'video') {
          this.getVideoThumbnail(event.target.files[i], '');
          continue;
        } else if (type[0] == 'application') {
          this.getPdfThumbnail(event.target.files[i], '');
          continue;
        } else if (type[0] == 'image') {
          this.getImageThumbnail(event.target.files[i], '');
          continue;
        }
      }
    }
  }

  /**
   * Used to validate the multiple file for size and filetype.
   */
  commonValidation(file): boolean {
    if (this.dss.allow_media_format.post_media.indexOf(file.type) === -1) {
      this.max_media_err.push(`${file.name} is not supported. Please upload mp4, jpg/jpeg, png, pdf file format only.`);
      return false;
    }
    if (this.masterSer.masterApiData.data.filesizelimit && (this.masterSer.masterApiData.data.filesizelimit * CONVERT_TO_BYTES_DECIMAL) < file.size) {
      this.max_media_err.push(`${file.name} is too large. Please upload smaller than ${this.masterSer.masterApiData.data.filesizelimit.video_maxlimit}mb.`);
      return false;
    }
    return true;
  }

  /**
   * get Video Thumbnail
   */
  getVideoThumbnail(videoFile, idx): void {
    this.fileUs.generateThumbnail(videoFile).then(data => {
      data = JSON.parse(data);
      const x = { local: data['data'], obj: videoFile, media_type: 'video' };
      console.log('======================', x);
      if (idx === '') {
        this.dss.temp_post_media.push(x);
      } else {
        this.dss.temp_post_media[idx] = x;
      }
      this.showColor = true;
    }).catch(() => {
      this.max_media_err.push(`Something wrong with the file ${videoFile.name}`);
    });
  }

  /**
   * get Image Thumbnail
   */
  getImageThumbnail(imgFile, idx): void {
    // const blob = window.URL.createObjectURL(imgFile);
    let x;
    const reader = new FileReader();
    reader.readAsDataURL(imgFile);
    reader.onloadend = function () {
      const base64data = reader.result;
      x = { local: base64data, obj: imgFile, media_type: 'image' };

    };

    setTimeout(() => {
      if (idx === '') {
        this.dss.temp_post_media.push(x);
      } else {
        this.dss.temp_post_media[idx] = x;
      }
      this.showColor = true;
    }, 500);
  }

  /**
   * get Pdf Thumbnail
   */
  getPdfThumbnail(pdfFile, idx): void {
    this.fileUs.generatePdfThumbnail(pdfFile).then(data => {
      data = JSON.parse(data);
      const x = { local: data['data'], obj: pdfFile, media_type: 'document' };
      setTimeout(() => {
        if (idx === '') {
          this.dss.temp_post_media.push(x);
        } else {
          this.dss.temp_post_media[idx] = x;
        }
      }, 500);

      this.showColor = true;
    }).catch(() => {
      this.max_media_err.push(`Something wrong with the file ${pdfFile.name}`);
    });
  }

  /**
   * onSelect Edit File
   */
  onSelectEditFile(event, idx): void {
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      for (let i = 0, j = this.dss.temp_post_media.length; i < filesAmount; i++, j++) {
        let type = event.target.files[i].type;
        type = type.split('/');
        if (type[0] == 'video') {
          this.getVideoThumbnail(event.target.files[i], idx);
          continue;
        } else if (type[0] == 'application') {
          this.getPdfThumbnail(event.target.files[i], idx);
          continue;
        } else if (type[0] == 'image') {
          this.getImageThumbnail(event.target.files[i], idx);
          continue;
        }
      }
    }
  }

  /**
   * remove Media
   */
  removeMedia(idx): void {
    this.max_media_err = [];
    if (this.dss.temp_post_media[idx].media_type == 'image') {
      this.dss.posting_data.screen1.media = this.dss.posting_data.screen1.media.filter(obj => obj.media_url != this.dss.temp_post_media[idx].local);
    } else if (this.dss.temp_post_media[idx].media_type == 'document' || this.dss.temp_post_media[idx].media_type == 'video') {
      this.dss.posting_data.screen1.media = this.dss.posting_data.screen1.media.filter(obj => obj.media_thumbnail != this.dss.temp_post_media[idx].local);
    }
    this.dss.temp_post_media.splice(idx, 1);
    this.showColor = (this.dss.temp_post_media.length > 0 || this.dss.posting_data.screen1.content != '') ? true : false;

    if (this.dss.edit_draft_index != '') {
      this.dss.posting_data.screen1.media = this.dss.temp_post_media;
    }

  }

  /**
   * reset Confirm Modal
   */
  resetConfirmModal(status): void {
    this.isConfirmModalShown = false;
    if (status == true) {
      const tempCommunityId = this.dss.posting_data.screen3.selected_community;
      this.dss.resetPostData();
      this.dss.posting_data.screen1.feed_kind = 'poll';
      this.showColor = false;
      this.content_paceholder = this.mls.languageText.create_posting.key8;
      this.max_media_err = [];
      if (this.dss.calling_from_community === NUMBERS.ONE) {
        this.dss.posting_data.screen3.selected_community = tempCommunityId;
      }
    }
  }

  /**
   * onPaste
   */
  onPaste(e): void {
    if (this.dss.posting_data.screen1.feed_kind == 'poll' || this.dss.temp_post_media.length > 0) { return; }
    if (this.dss.posting_data.screen1.media.length == 0) {
      let content = '';

      if (e.clipboardData != undefined) {
        content = e.clipboardData.getData('text/plain');
        const isUrl = this.fcs.validURL(content);
        if (isUrl == false) { return; }

      } else {
        content = e.target.value.trim();
        const isUrl = this.fcs.validURL(content);
        if (isUrl == false) { return; }

      }

      // eslint-disable-next-line no-useless-escape
      const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;

      content.replace(replacePattern1, function (url) {
        contentUrl = url;
        return '<a href="' + url + '">' + url + '</a>';
      });
      this.meta_api_in_process = (this.dss.posting_data.screen1.metaData == '') ? true : false;
      if (this.dss.posting_data.screen1.metaData != '') { return; }
      this.subscriptions.add(this.getSer.getFeedMeta(contentUrl).subscribe(data => {
        this.meta_api_in_process = false;
        const responceData = data;
        if (responceData.status === NUMBERS.ONE) {
          this.metaData = responceData.data;
          this.dss.posting_data.screen1.metaData = this.metaData;
        }
      }, () => {
        this.meta_api_in_process = false;
      }));
    }
  }

  /**
   * cancel Meta
   */
  cancelMeta(): void {
    this.metaData = '';
    this.dss.posting_data.screen1.metaData = '';
  }

  /**
   * tag People
   */
  tagPeople(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.OPTION_BAR, ACTION_TYPE.CLICK, ACTION_ON.TAG_PEOPLE, null);
    if (this.profile_data.profile.is_verified == 1) {
      this.nextPostScreen.emit(1);
    } else {
      sessionStorage.removeItem('resub');
      this.assignAssociation();
    }
  }

  /**
   * open speciality selection list
   */
  openspecialitySelectionList(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.BAR, ACTION_TYPE.CLICK, ACTION_ON.POSTING_OPTIONS, null);
    this.nextPostScreen.emit(2);
  }

  /**
   * assign Association
   */
  assignAssociation(): void {
    this.dss.selected_suggAssList = [];
    this.subscriptions.add(this.postApiSer.assignAssociation('association', '[]', '', 0).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          if (data['code'] == 2000) {
            this.displayObj.isShow = true;
            this.displayObj.display_section = 'verificationSuccess';
            this.displayObj.data = data['data'];
            this.displayObj.errObj = [];
            this.masterSer.showWebModal.next(this.displayObj);
          }
        } else {
          this.fcs.errorHandeler(data);
          return;
        }
      });
    }));
  }

  /**
   * open Post Media Modal
   */
  openPostMediaModal(idx, data): void {
    this.pencilEditMedia = data.media_id;
    this.is_show_post_media_modal_data = [];
    this.is_show_post_media_modal_data.push(data);
    if (data.media_type == 'image') {
      this.dss.canvas_image_edit_obj.is_show = true;
      this.dss.canvas_image_edit_obj.index = idx;
      this.dss.canvas_image_edit_obj.base64Str = data.local;
      this.dss.canvas_image_edit_obj.calling_from = 'postscreen';
    }
  }

  /**
   * save Updated Image
   */
  saveUpdatedImage(base64Str): void {
    this.dss.temp_post_media[this.dss.canvas_image_edit_obj.index].local = base64Str;

    this.dss.posting_data.screen1.media = this.dss.posting_data.screen1.media.filter(obj => obj.media_id !== this.pencilEditMedia);
    this.pencilEditMedia = 0;
    this.dss.temp_post_media[this.dss.canvas_image_edit_obj.index].obj = this.fileUsFork.dataURItoBlob(base64Str);

    setTimeout(() => {
      this.fcs.resetCanvasImageEditObj();
    }, 300);

  }

  /**
   * reset Post Media Modal
   */
  resetPostMediaModal(): void {
    this.is_show_post_media_modal_data = [];
    this.is_show_post_media_modal = false;
  }

  /**
   * navigate to profile
   */
  navigatetoprofile(cstmid): void {
    this.fcs.navigateToUserInfo(cstmid);
  }

  /**
   * set Reset Media Modal
   */
  setResetMediaModal(val, indx): void {
    if (indx == undefined) {
      this.openMediaIndex = 0;
    }
    this.mediaModal = val;
    if (indx != '' && indx != undefined) { this.openMediaIndex = indx; }
  }

  /**
   * view pdf
   */
  viewpdf(idx): void {
    if (this.dss.temp_post_media[idx].obj == 'edit') {
      return;
      const t = {
        media_id: idx,
        media_name: '',
        media_thumbnail: '',
        media_type: 'documentEdit',
        media_url: this.dss.temp_post_media[idx].mediaurl
      };
      this.mediaObj.unshift(t);
      setTimeout(() => {
        this.mediaModal = true;
      }, 500);

    } else {
      const t = {
        media_id: idx,
        media_name: '',
        media_thumbnail: '',
        media_type: 'documentPost',
        media_url: this.dss.temp_post_media[idx].obj
      };
      this.mediaObj.unshift(t);
      setTimeout(() => {
        this.mediaModal = true;
      }, 500);
    }
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    /**
     * Calculate end time on destroy.
     */
    this.sessiontime.end_time = new Date().getTime().toString();
    /**
     * Set analyics data on ngDestroy.
     */
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0',
      current_screen_name: SCREEN_NAME.FEED_POSTING,
      start_time: parseInt(this.sessiontime.start_time),
      end_time: parseInt(this.sessiontime.end_time)
    };
    this.analyticSdk.analyticService.EXIT(exitData);

    if (!this.dss.repostProductId) {
      this.dss.isRepostStatus = REPOST_STATUS.ZERO;
      this.dss.webinarRepostObject = '';
    }
  }

  /**
   * Conver url to base64 for repost cme url to file.
   */
  convertToBase64(url: string): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const headers = {
      'Content-Type': 'application/pdf'
    };
    fetch(url)
      .then(res => res.blob()) // Gets the response and returns it as a blob
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (event) => {
          console.log('file', event);
          this.urltoFile(event.target.result, 'cmeCertificate.pdf', 'application/pdf').then((file) => {
            this.urlToFiles = file;
            this.getPdfThumbnail(this.urlToFiles, '');
          });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reader.onerror = (event: any) => {
          console.log('File could not be read: ' + event.target.error.code);
        };
      });
    // this.http.get(url).subscribe((data) => {
    //   console.log('data', data);
    //   const reader = new FileReader();
    //   reader.onload = (event) => {
    //     console.log('file', event);
    //     this.urltoFile(event.target.result, 'cmeCertificate.pdf', 'application/pdf').then((file) => {
    //       this.urlToFiles = file;
    //       this.getPdfThumbnail(this.urlToFiles, '');
    //     });
    //   };
    //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //   reader.onerror = (event: any) => {
    //     console.log('File could not be read: ' + event.target.error.code);
    //   };
    // });
  }
  /**
   * return a promise that resolves with a File instance.
   */
  urltoFile(url, filename, mimeType): Promise<File> {
    return (fetch(url)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], filename, { type: mimeType }))
    );
  }

  /**
   * Default repost description.
   */
  repostdefaultContent(): void {
    this.subscriptions.add(this.getSer.repostdefaultContent(this.dss.repostProductType, this.dss.repostProductId).subscribe(resData => {
      if (resData.status === NUMBERS.ONE) {
        this.dss.posting_data.screen1.content = resData.data.description;
        this.dss.repostAssociationHint = resData.data.hint;
        this.showColor = true;
      } else {
        this.fcs.errorHandeler(resData);
      }
    }));
  }
  /**
   * file Uploading Process
   */
  fileUploadingProcess(): void {
    if((this.dss.posting_data.screen3.selected_community.length === NUMBERS.ZERO &&
       this.dss.posting_data.screen3.selected_association.length === NUMBERS.ZERO )){
            this.postPopup = true;
       }
    else{
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.CREATE_FEED_POST, null);
    this.postApiSer.setPostButtonStatus(true);
    this.nextPostScreen.emit(6.1);
    this.uploadFile();
    }
  }

  /**
   * open draft list screen
   */
  openDraftList(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.CREATE_REPOST, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.OPEN_DRATS_LIST, null);
    this.nextPostScreen.emit(3);
  }

  /**
   * upload File
   */
  uploadFile(): void {
    this.dss.calling_from_community = NUMBERS.ZERO;
    if (this.dss.posting_data.feed_edit_mode.is_edit === NUMBERS.ONE) {
      this.uploadFileForEditFeedPost(); return;
    }
    if (this.dss.posting_data.screen1.feed_kind !== FEED_KIND.POLL) {
      this.dss.posting_data.screen1.feed_kind = FEED_KIND.POST;
    }
    this.postingService.uploadFile();
  }

  /**
   * upload File For Edit Feed Post
   */
  uploadFileForEditFeedPost(): void {
    this.postingService.uploadFileForEditFeedPost();
  }
  /**
   * On clicking update the variable
   */
  isDraftPost(): void {
    this.dss.isDraftPost = NUMBERS.ONE;
  }
  
  /**
   * Method for getting association
   */
  getUserAssociation(): void {
    let repostParam = {
      product_id: NUMBERS.ZERO,
      product_type: NUMBERS.ZERO
    };
    if(this.dss.isRepostStatus === REPOST_STATUS.TWO){
      repostParam = {
        product_id: this.dss.repostProductId,
        product_type :this.dss.repostProductType
      }
    }
    this.subscriptions.add(this.getSer.getUserAssociation(repostParam).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status === NUMBERS.ONE) {
          if (data.code === STATUS_CODE.TWO_THOUSAND) {
            this.dss.user_association_list = data.data.user_association_list;
            if (this.dss.user_association_list.length === NUMBERS.ONE && (this.dss.posting_data && this.dss.posting_data.feed_edit_mode && !(this.dss.posting_data.feed_edit_mode.feed_id))) {
              if (this.dss.posting_data.screen3.selected_association.indexOf(parseInt(this.dss.user_association_list[0].association_id)) < NUMBERS.ZERO) {
                this.dss.posting_data.screen3.selected_association.push(this.dss.user_association_list[0].association_id);
              }
            } else {
              if (this.dss.posting_data && this.dss.posting_data.feed_edit_mode && !(this.dss.posting_data.feed_edit_mode.feed_id)) {
                for (let listIndex = 0; listIndex < this.dss.user_association_list.length; listIndex++) {
                  if (this.dss.user_association_list[listIndex].is_public == '1' || this.dss.user_association_list[listIndex].is_public === NUMBERS.ONE || this.dss.isRepostStatus === REPOST_STATUS.TWO ) {
                    if (this.dss.posting_data.screen3.selected_association.indexOf(parseInt(this.dss.user_association_list[listIndex].association_id) < NUMBERS.ZERO)) {
                      this.dss.posting_data.screen3.selected_association.push(this.dss.user_association_list[listIndex].association_id);
                    }
                  }

                }
              }
            }
            this.dss.posting_data.screen3.selected_association = [...new Set(this.dss.posting_data.screen3.selected_association)];
            if(this.dss.calling_from_community
              && !(this.dss.posting_data.feed_edit_mode.feed_id)) {
              this.dss.posting_data.screen3.selected_association = [];
            }
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      }, err => {
      });
    }));
  }


   /**
   * get Speciality List
   */
   getSpecialityList(): void {
    this.subscriptions.add(this.getSer.getClinicalspecialityList().subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] === NUMBERS.ONE) {
          if (data['code'] === NUMBERS.TWO_THOUSAND) {
            this.dss.speciality_list = data['data'].speciality_list;
            this.dss.posting_speciality_count = data['data'].posting_speciality_count;

              if (this.dss.posting_data.screen2.selected_speciality.length === NUMBERS.ZERO && this.dss.speciality_list != undefined) {
                if (this.dss.speciality_list.length > NUMBERS.ZERO && this.dss.calling_from_community !== NUMBERS.ONE && this.dss.communityExists !== NUMBERS.ONE) {
                  this.dss.posting_data.screen2.selected_speciality = this.dss.speciality_list.filter(x => x.is_primary === NUMBERS.ONE);
                }
              }
            
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }


  /**
   * Method for closing post pop up
   */
  postPopClose() : void {
    this.postPopup = false;
  }

}
